import { render } from "./OtherResult.vue?vue&type=template&id=b1537d1a&scoped=true"
import script from "./OtherResult.vue?vue&type=script&lang=js"
export * from "./OtherResult.vue?vue&type=script&lang=js"

import "./OtherResult.vue?vue&type=style&index=0&id=b1537d1a&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1537d1a"]])

export default __exports__